<template>
  <layout>
    <template v-slot:header>
      <AppHead title="New MTD" />
      <h2>New Mobile Tool Distributor</h2>
      <BreadCrumbs activeItem="New MTD" :crumbs="{ home: 'Dashboard', mtd: 'MTDS'}"/>
      <flash-messages />
    </template>
    
    <template v-slot:default>
      <form @submit.prevent="store">
        <card title="New MTD" class="mb-4" icon="fas fa-plus">
          <div class="row">
            <div class="form-group col-sm-6">
              <jet-label for="company_name" value="Company name" />
              <jet-input id="company_name"  type="text" class="form-control" v-model="form.company_name" />
              <jet-input-error :message="form.errors.company_name" class="mt-2" />
            </div>
            <div class="form-group col-sm-6">
              <div class="col-span-12">
                <jet-label for="mtd_service_area" value="Service Area" />
                <jet-input id="mtd_service_area"  type="text" class="form-control" v-model="form.mtd_service_area" />
                <jet-input-error :message="form.errors.mtd_service_area" class="mt-2" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-sm-6">
              <jet-label for="first_name" value="First name" />
              <jet-input id="first_name"  type="text" class="form-control" v-model="form.first_name" />
              <jet-input-error :message="form.errors.first_name" class="mt-2" />
            </div>
            <div class="form-group col-sm-6">
              <jet-label for="last_name" value="Last name" />
              <jet-input id="last_name"  type="text" class="form-control" v-model="form.last_name" />
              <jet-input-error :message="form.errors.last_name" class="mt-2" />
            </div>
            <div class="form-group col-sm-6">
              <jet-label for="email" value="Email" />
              <jet-input id="email"  type="text" class="form-control" v-model="form.email" />
              <jet-input-error :message="form.errors.email" class="mt-2" />
            </div>
            <div class="form-group col-sm-6">
              <jet-label for="phone" value="Phone" />
              <jet-input id="phone"  type="text" class="form-control" v-model="form.phone_number" />
              <jet-input-error :message="form.errors.phone_number" class="mt-2" />
            </div>
          </div>

          <div class="row">
            <div class="form-group col-sm-6">
              <jet-label for="mtd_info_dob" value="DOB" />
              <Calendar v-model="form.mtd_info_dob" class="w-100" id="mtd_info_dob" :showIcon="true" :selectOtherMonths="true"/>
              <jet-input-error :message="form.errors.mtd_info_dob" class="mt-2" />
              <p>Click year in calendar to first go back to year</p>
            </div>
            <div class="form-group col-sm-6">
              <jet-label for="mtd_info_ssn_last4" value="SSN Last 4" />
              <jet-input id="mtd_info_ssn_last4"  type="text" class="form-control" v-model="form.mtd_info_ssn_last4" />
              <jet-input-error :message="form.errors.last_name" class="mt-2" />
            </div>
            <div class="form-group col-sm-6">
              <jet-label for="mtd_info_ein" value="EIN (tax ID)" />
              <jet-input id="mtd_info_ein"  type="text" class="form-control" v-model="form.mtd_info_ein" />
              <jet-input-error :message="form.errors.mtd_info_ein" class="mt-2" />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-sm-6">
              <jet-label for="mtd_assigned_rsm_id" value="Assigned RSM" />
              <select class="form-control" v-model="form.mtd_assigned_rsm_id">
              <option v-for="rsm in this.rsms" :key="rsm.first_name" :value="rsm.id">
              {{ rsm.first_name }} {{ rsm.last_name }}
              </option>
              </select>
              <jet-input-error :message="form.errors.mtd_assigned_rsm_id" class="mt-2" />
            </div>
            <div class="form-group col-sm-6">
              <jet-label for="mtd_assigned_rsm_id" value="Tier" />
              <select class="form-control" v-model="form.mtd_plan_id" size="3">
                <option v-for="plan in this.plans" :key="plan.id" :value="plan.id">
                  {{ plan.name }}
                </option>
              </select>
              <jet-input-error :message="form.errors.mtd_plan_id" class="mt-2" />
            </div>
          </div>          


        </card>
        
        <div class="row mb-4">
          <div class="col-12 col-lg-6 mb-3 mb-lg-0">
            <card class="h-100" title="Billing Address">
              <div class="row">
                <div class="form-group col-sm-6">
                  <jet-label for="address1" value="Address" />
                  <GMapAutocomplete
                    id="address1"
                    class="form-control"
                    placeholder="Start typing billing address.."
                    @place_changed="getBillingAddressData"
                    @change="changeBillingAddressData"
                  />
                  <jet-input-error :message="form.errors.address1" class="mt-2" />
                </div>
                <div class="form-group col-sm-6">
                  <jet-label for="address2" value="Unit / Suite" />
                  <jet-input id="address2"  type="text" class="form-control" v-model="form.address2" />
                  <jet-input-error :message="form.errors.address2" class="mt-2" />
                </div>
              </div>

              <div class="row">
                <div class="form-group col-sm-6">
                  <jet-label for="city" value="City" />
                  <jet-input id="city"  type="text" class="form-control" v-model="form.city" />
                  <jet-input-error :message="form.errors.city" class="mt-2" />
                </div>
                <div class="form-group col-sm-6">
                  <jet-label for="state" value="State" />
                  <select v-model="form.state" class="form-control">
                    <option v-for="state in statesByCountry" :key="state.code" :value="state.code">
                      {{ state.code }} - {{ state.name }}
                    </option>
                  </select>
                  <jet-input-error :message="form.errors.state" class="mt-2" />
                </div>
              </div>

              <div class="row">
                <div class="form-group col-sm-6">
                  <jet-label for="postcode" value="Zip" />
                  <jet-input id="postcode"  type="text" class="form-control" v-model="form.postcode" />
                  <jet-input-error :message="form.errors.postcode" class="mt-2" />
                </div>
                <div class="form-group col-sm-6">
                  <jet-label for="country" value="Country" />
                  <select v-model="form.country" class="form-control">
                    <option v-for="country in countries" :key="country.iso_code_2" :value="country.iso_code_2">
                      {{ country.iso_code_2 }} - {{ country.name }}
                    </option>
                  </select>
                  <jet-input-error :message="form.errors.country" class="mt-2" />
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-6">
                  <jet-button type="button" icon="fas fa-copy" @click="copyBilling">Copy to Shipping</jet-button>
                </div>
              </div>
            </card>
          </div>

          <div class="col-12 col-lg-6">
            <card class="h-100" title="Shipping Address">
              <div class="row">
                <div class="form-group col-sm-6">
                  <jet-label for="ship_address1" value="Address" />
                  <GMapAutocomplete
                    id="ship_address1"
                    ref="shippingAddress"
                    class="form-control"
                    placeholder="Start typing shipping address.."
                    @place_changed="getShippingAddressData"
                    @change="changeShippingAddressData"
                  />
                  <jet-input-error :message="form.errors.ship_address1" class="mt-2" />
                </div>
                <div class="form-group col-sm-6">
                  <jet-label for="ship_address2" value="Unit / Suite" />
                  <jet-input id="ship_address2"  type="text" class="form-control" v-model="form.ship_address2" />
                  <jet-input-error :message="form.errors.ship_address2" class="mt-2" />
                </div>
              </div>

              <div class="row">
                <div class="form-group col-sm-6">
                  <jet-label for="ship_city" value="City" />
                  <jet-input id="ship_city"  type="text" class="form-control" v-model="form.ship_city" />
                  <jet-input-error :message="form.errors.ship_city" class="mt-2" />
                </div>
                <div class="form-group col-sm-6">
                  <jet-label for="ship_state" value="State" />
                  <select v-model="form.ship_state" class="form-control">
                      <option v-for="state in shipStatesByCountry" :key="state.code" :value="state.code">
                        {{ state.code }} - {{ state.name }}
                      </option>
                    </select>
                  <jet-input-error :message="form.errors.ship_state" class="mt-2" />
                </div>
              </div>

              <div class="row">
                <div class="form-group col-sm-6">
                  <jet-label for="ship_postcode" value="Zip" />
                  <jet-input id="ship_postcode"  type="text" class="form-control" v-model="form.ship_postcode" />
                  <jet-input-error :message="form.errors.ship_postcode" class="mt-2" />
                </div>
                <div class="form-group col-sm-6">
                  <jet-label for="ship_country" value="Country" />
                  <select v-model="form.ship_country" class="form-control">
                    <option v-for="country in countries" :key="country.iso_code_2" :value="country.iso_code_2">
                      {{ country.iso_code_2 }} - {{ country.name }}
                    </option>
                  </select>
                  <jet-input-error :message="form.errors.ship_country" class="mt-2" />
                </div>
              </div>
            </card>
          </div>

          <div class="col-12 col-lg-6">
              <EditTags :draft="true" v-model="userTags" :tags="tags"></EditTags>
          </div>
        </div>
        
        <div class="bottom-button mb-3">
          <jet-button class="px-5" btnStyle="success" icon="fas fa-shopping-cart" :disable="form.processing" @click="store">Create User</jet-button>
        </div>
      </form>
    </template>
  </layout>
</template>

<script>
  import Layout from '@/Shared/Admin/Layout'
  import EditTags from "@/Shared/EditTags";
  import FileInput from '@/Shared/FileInput'
  import TextInput from '@/Shared/TextInput'
  import SelectInput from '@/Shared/SelectInput'

  import JetButton from '@/Jetstream/Button'
  import JetFormSection from '@/Jetstream/FormSection'
  import JetInput from '@/Jetstream/Input'
  import JetCheckbox from '@/Jetstream/Checkbox'
  import JetInputError from '@/Jetstream/InputError'
  import JetLabel from '@/Jetstream/Label'
  import JetActionMessage from '@/Jetstream/ActionMessage'
  import BreadCrumbs from '@/Shared/BreadCrumbs'

  import Calendar from 'primevue/calendar';
  import Helpers from '@/Helpers'

  export default {
    components: {
      Calendar,
      EditTags,
      FileInput,
      SelectInput,
      TextInput,
      JetActionMessage,
      JetButton,
      JetFormSection,
      JetInput,
      JetCheckbox,
      JetInputError,
      JetLabel,
      Layout,
      BreadCrumbs
    },
    remember: 'form',
    props: {
      roles: Object,
      rsms: Array,
      plans: Array,
      countries: Array,
      tags: Array,
      states: Array
    },
    data() {
      return {
        userTags: [],
        form: this.$inertia.form({
          company_name: null,
          first_name: null,
          last_name: null,
          email: null,
          phone_number: null,
          mtd_info_dob: null,
          mtd_info_ssn_last4: null,
          mtd_info_ein: null,
          address1: null,
          address2: null,
          city: null,
          state: null,
          country: null,
          postcode: null,
          ship_address1: null,
          ship_address2: null,
          ship_city: null,
          ship_state: null,
          ship_country: null,
          ship_postcode: null,
          mtd_assigned_rsm_id: null,
          tags: [],
          mtd_service_area: null,
          mtd_plan_id: 2          
        })
      }
    },
    computed: {
      shipStatesByCountry() {
        if (!this.form.ship_country) {
          return this.states
        }
        return this.states.filter(s => s.country_code == this.form.ship_country)
      },
      statesByCountry() {
        if (!this.form.country) {
          return this.states
        }
        return this.states.filter(s => s.country_code == this.form.country)
      }
    },
    watch: {
      'form.state'(val) {
        const state = this.states.find(s => s.code == val)
        this.form.country = state?.country_code
      },
      'form.ship_state'(val) {
        const state = this.states.find(s => s.code == val)
        this.form.ship_country = state?.country_code
      },
    },
    methods: {
      copyBilling() {
        document.getElementById('ship_address1').value = this.form.address1
        this.form.ship_address1 = this.form.address1;
        this.form.ship_address2 = this.form.address2;
        this.form.ship_city = this.form.city;
        this.form.ship_state = this.form.state;
        this.form.ship_postcode = this.form.postcode;
        this.form.ship_country = this.form.country;
      },
      changeBillingAddressData(e) {
        this.form.address1 = e.target.value
      },
      changeShippingAddressData(e) {
        this.form.ship_address1 = e.target.value
      },
      getBillingAddressData(info) {
        const city = Helpers.getAddressComponent('locality', info)
        const state = Helpers.getAddressComponent('administrative_area_level_1', info)
        const zipcode = Helpers.getAddressComponent('postal_code', info)
        const street_number = Helpers.getAddressComponent('street_number', info)
        const route = Helpers.getAddressComponent('route', info)
        let address1 = '';
        if (street_number.length && route.length) {
          address1 = street_number[0].long_name + ' ' + route[0].short_name;
        } else if (info.name) {
          address1 = info.address
        }
        this.form.address1 = address1
        document.getElementById('address1').value = address1
        if (city.length) this.form.city = city[0].long_name
        if (state.length) this.form.state = state[0].short_name
        if (zipcode.length) this.form.postcode = zipcode[0].long_name
      },
      getShippingAddressData(info) {
        const city = Helpers.getAddressComponent('locality', info)
        const state = Helpers.getAddressComponent('administrative_area_level_1', info)
        const zipcode = Helpers.getAddressComponent('postal_code', info)

        const street_number = Helpers.getAddressComponent('street_number', info)
        const route = Helpers.getAddressComponent('route', info)
        let address1 = '';
        if (street_number.length && route.length) {
          address1 = street_number[0].long_name + ' ' + route[0].short_name;
        } else if (info.name) {
          address1 = info.address
        }
        this.form.address1 = address1
        document.getElementById('ship_address1').value = address1
        if (city.length) this.form.ship_city = city[0].long_name
        if (state.length) this.form.ship_state = state[0].short_name
        if (zipcode.length) this.form.ship_postcode = zipcode[0].long_name
      },
      store() {
        this.form.address1 = document.getElementById('address1').value
        this.form.ship_address1 = document.getElementById('ship_address1').value
        this.form.tags = this.userTags.map(t => t.name)
        this.form.post(this.route('users.storemtd'))
      },
    },
  }
</script>
